import React from "react";
import { Col, Grid, Row } from "react-material-responsive-grid";
import { AppEnv } from "../../env";
import { getLogo } from "../../Global-W/NewFunctions";
import { modalSolicitud } from "../../../redux/actions";
import { useDispatch } from "react-redux";

export default function Header() {
  const dispatch = useDispatch();
  return (
    <Grid
      style={{
        margin: 0,
        padding: 0,
      }}
      className="uk-width-1-1 centerAll"
    >
      <Row
        style={{
          margin: 0,
          padding: 0,
        }}
        className="uk-width-1-1 centerAll"
      >
        <Row
          className="uk-width-1-1 centerAll"
          style={{ margin: 0, padding: 5, backgroundColor: AppEnv.mainColor }}
        >
          <Col
            xl={8}
            lg={8}
            md={8}
            sm={8}
            xs4={4}
            style={{
              margin: 0,
              padding: 0,
            }}
            className="centerAll uk-width-1-1"
          >
            <Row className="uk-width-1-1 centerAll">
              <Row className="centerAll uk-visible@m uk-width-1-3@l uk-width-1-2@s uk-width-1-1">
                <label
                  className=" normal_text"
                  style={{
                    color: "white",
                    fontSize: 12,
                    fontWeight: 400,
                    marginRight: 5,
                  }}
                >
                  SI ESTÁS EN
                </label>
                <img
                  alt=""
                  className="lazyload"
                  data-src="https://img.icons8.com/color/24/000000/mexico.png"
                />
                <label
                  onClick={() => window.open("tel:8001200058", "_blank")}
                  className=" normal_text"
                  style={{
                    color: "white",
                    fontSize: 12,
                    fontWeight: 400,
                    marginLeft: 5,
                  }}
                >
                  LLÁMANOS AL
                </label>
                <label
                  className=" normal_text"
                  style={{
                    color: "white",
                    fontSize: 12,
                    fontWeight: 700,
                    marginLeft: 5,
                  }}
                >
                  800 120 00 58
                </label>
              </Row>

              {/*<Row className="centerAll uk-visible@m uk-width-1-6">*/}
              {/*    <label className=" normal_text" style={{*/}
              {/*        color: "white",*/}
              {/*        fontSize: 12,*/}
              {/*        fontWeight: 200,*/}
              {/*    }}>|</label>*/}
              {/*</Row>*/}

              <Row className="centerAll uk-visible@l uk-width-1-3@l uk-width-1-2@s uk-width-1-1">
                <label
                  className=" normal_text"
                  style={{ color: "white", fontSize: 12, fontWeight: 400 }}
                >
                  ÚNETE DESDE
                </label>
                <img
                  alt=""
                  style={{ marginLeft: 10 }}
                  className="lazyload"
                  data-src="https://img.icons8.com/color/24/000000/mexico.png"
                />
                <img
                  alt=""
                  style={{ marginLeft: 5 }}
                  className="lazyload"
                  data-src="https://img.icons8.com/color/24/000000/spain.png"
                />
                <img
                  alt=""
                  style={{ marginLeft: 5 }}
                  className="lazyload"
                  data-src="https://img.icons8.com/color/24/000000/argentina.png"
                />
                <img
                  alt=""
                  style={{ marginLeft: 5 }}
                  className="lazyload"
                  data-src="https://img.icons8.com/color/24/000000/colombia.png"
                />
                <img
                  alt=""
                  style={{ marginLeft: 5 }}
                  className="lazyload"
                  data-src="https://img.icons8.com/color/24/000000/peru.png"
                />
                <img
                  alt=""
                  style={{ marginLeft: 5 }}
                  className="lazyload"
                  data-src="https://img.icons8.com/color/24/000000/chile.png"
                />
                <label
                  className=" normal_text"
                  style={{
                    color: "white",
                    fontSize: 12,
                    fontWeight: 400,
                    marginLeft: 5,
                  }}
                >
                  Y 15 PAÍSES MÁS
                </label>
              </Row>

              {/*<Row className="centerAll uk-visible@l uk-width-1-6">*/}
              {/*    <label className=" normal_text" style={{*/}
              {/*        color: "white",*/}
              {/*        fontSize: 12,*/}
              {/*        fontWeight: 200,*/}
              {/*    }}>|</label>*/}
              {/*</Row>*/}

              <Row className="centerAll uk-width-1-3@l uk-width-1-2@s uk-width-1-1">
                <label
                  className=" normal_text"
                  style={{ color: "white", fontSize: 12, fontWeight: 400 }}
                >
                  SOPORTE TÉCNICO INTERNACIONAL
                </label>
                <label
                  onClick={() =>
                    window.open("https://wa.me/5212282205275", "_blank")
                  }
                  className=" normal_text"
                  style={{
                    color: "white",
                    fontSize: 9,
                    backgroundColor: "#00bb2d",
                    padding: 5,
                    borderRadius: 3,
                    fontWeight: 400,
                    marginLeft: 15,
                  }}
                >
                  MENSAJE
                </label>
              </Row>
            </Row>
          </Col>
        </Row>

        <Row
          style={{
            margin: 0,
            padding: "2vh 0vh 2vh 0vh",
            backgroundColor: "transparent",
          }}
          className="centerAll uk-width-5-6@m"
        >
          <Col
            xl={2}
            lg={2}
            md={2}
            sm={2}
            xs4={2}
            xs8={4}
            style={{
              margin: 0,
              padding: 0,
              paddingLeft: 0,
              paddingTop: 0,
            }}
          >
            <Row className="centerAll uk-width-1-1">
              <Row
                onClick={() => window.open("/", "_self")}
                className="centerAll"
              >
                <img
                  alt=""
                  className="logolanding lazyload"
                  data-src={getLogo()}
                />
              </Row>
            </Row>
          </Col>

          <Col
            xl={5}
            lg={5}
            md={5}
            sm={5}
            xs4={0}
            xs8={0}
            style={{ paddingTop: 0 }}
          >
            <Row className="centerAll uk-width-1-1"></Row>
          </Col>
          <Col
            hiddenDown="sm"
            xl={1}
            lg={1}
            md={1}
            sm={1}
            xs4={1}
            xs8={1}
            style={{
              margin: 3,
              padding: "5px 10px 5px 10px",
              textAlign: "center",
              backgroundColor: AppEnv.grayColorOne,
              borderRadius: 5,
            }}
          >
            <Row className="centerAll uk-width-1-1">
              <a href={"/#contacto"} className="uk-link-text">
                <div className="centerAll ">
                  <i className="fas fa-envelope fa-1x Color1" />
                  <label
                    style={{
                      marginLeft: 10,
                      color: AppEnv.mainColor,
                      fontWeight: 600,
                    }}
                    className="normal_text"
                  >
                    CONTACTO
                  </label>
                </div>
              </a>
            </Row>
          </Col>
          <Col
            hiddenDown="sm"
            xl={1}
            lg={1}
            md={1}
            style={{
              margin: 3,
              padding: "5px 10px 5px 10px",
              textAlign: "center",
              backgroundColor: AppEnv.grayColorOne,
              borderRadius: 5,
            }}
            onClick={() => dispatch(modalSolicitud(true, "registro"))}
          >
            <Row className="centerAll uk-width-1-1 ">
              <div className="centerAll ">
                <i className="fas fa-chalkboard-teacher fa-1x Color1" />
                <label
                  style={{
                    marginLeft: 10,
                    color: AppEnv.mainColor,
                    fontWeight: 600,
                  }}
                  className="normal_text"
                >
                  INFORMES
                </label>
              </div>
            </Row>
          </Col>
          <Col
            className="centerV uk-animation-toggle"
            tabIndex="0"
            xl={1}
            lg={1}
            md={1}
            style={{
              margin: 3,
              padding: "5px 15px 5px 15px",
              textAlign: "center",
              backgroundColor: AppEnv.secondColor,
              borderRadius: 5,
            }}
          >
            <Row
              onClick={() => (window.location.href = AppEnv.url + "/Login")}
              className="centerAll uk-animation-shake uk-width-1-1 "
            >
              <div className="centerAll ">
                <i
                  style={{ color: AppEnv.fourthColor }}
                  className="fas fa-sign-in-alt fa-1x"
                />
                <label
                  style={{
                    marginLeft: 10,
                    color: AppEnv.fourthColor,
                    fontWeight: 600,
                  }}
                  className="normal_text"
                >
                  ENTRAR
                </label>
              </div>
            </Row>
          </Col>
        </Row>
      </Row>
    </Grid>
  );
}
